import React from "react";
import ForgetPasswordsContainer from "modules/Authentication/containers/ForgetPasswordsContainer/ForgetPasswordsContainer";

type Props = {};

const ForgetPasswords = (props: Props) => {
  return <ForgetPasswordsContainer />;
};

export default ForgetPasswords;
